import { Skeleton, Stack } from '@mui/material';
import { ID } from '@/data/types/Basic';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { useParams } from 'next/navigation';

const HeaderCenefaShipping = ({ id }: { id: ID }) => (
	<ContentRecommendation
		id={`${id}-HeaderCenefaShipping`}
		properties={{
			emsName: 'HeaderCenefaShipping',
		}}
		loadingElement={
			<Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Skeleton width={200} height={20} />
			</Stack>
		}
	/>
);

const HeaderCenefaShippingMobile = ({ id }: { id: ID }) => (
	<ContentRecommendation
		id={`${id}-HeaderCenefaShippingMobile`}
		properties={{
			emsName: 'HeaderCenefaShippingMobile',
		}}
		loadingElement={
			<Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Skeleton width={200} height={20} />
			</Stack>
		}
		emptyElement={<HeaderCenefaShipping id={id} />}
	/>
);

const HeaderCenefaLogos = ({ id }: { id: ID }) => (
	<ContentRecommendation
		id={`${id}-HeaderCenefaLogos`}
		properties={{
			emsName: 'HeaderCenefaLogos',
		}}
		loadingElement={
			<Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Skeleton width={300} height={26} />
			</Stack>
		}
	/>
);

export const Promotions: React.FC<{
	id: ID;
	mobile?: boolean;
}> = ({ id, mobile }) => {
	const path = useParams();
	return (
		<Stack direction="column" justifyContent="center">
			{!Object.keys(path).length ? <HeaderCenefaLogos id={id} /> : null}
			{mobile ? <HeaderCenefaShippingMobile id={id} /> : <HeaderCenefaShipping id={id} />}
		</Stack>
	);
};
